import { Button } from "@/components/kit";
import { Icon } from "@/lib/icons";

const money = (c) => `$${((c || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

// Shared thank-you screen shown after a gift. Reusable by a public page later.
export default function ThankYou({ donation, onDone }) {
  const paid = donation.status === "paid";
  return (
    <div data-testid="give-thankyou" className="text-center py-4">
      <div className="w-14 h-14 rounded-full bg-dark-olive/15 flex items-center justify-center mx-auto mb-3">
        <Icon name="HeartHandshake" className="w-7 h-7 text-dark-olive" />
      </div>
      <h3 className="font-zilla text-2xl font-semibold mb-1">Thank you!</h3>
      <p className="text-[15px] text-ink/70">
        Your gift of <b>{money(donation.amount_cents)}</b> on {(donation.date || "").slice(0, 10)}
        {donation.campaign_title ? ` to ${donation.campaign_title}` : ""}.
      </p>
      {donation.simulated ? (
        <p className="text-[13px] text-ink/55 mt-2">This was a simulated gift — not a real charge.</p>
      ) : paid ? (
        <p className="text-[13px] text-ink/55 mt-2" data-testid="give-receipt-note">A receipt has been emailed to you.</p>
      ) : (
        <p className="text-[13px] text-maroon mt-2">Status: {donation.status}</p>
      )}
      <Button data-testid="give-thankyou-done" onClick={onDone} className="mt-4">Done</Button>
    </div>
  );
}
